import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const TableWrapper = styled.div`
  display: grid;
  width: 100%;
  overflow-x: auto;
  gap: ${theme.spacing.xm};
  max-height: 530px;
`

export const BadgesWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${theme.spacing.xs};
  width: 100%;
`
